// @flow
import React from 'react';
import './CoverImage.css';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

export type Props = {
  imageId: string,
};

const CoverImage = ({imageId}: Props) => (
  <div
    className="CoverImage"
    style={{
      backgroundImage: `url(${fileUrl}/preview/${imageId})`,
    }}>
  </div>
);

export default CoverImage;



// WEBPACK FOOTER //
// ./src/components/CoverImage/CoverImage.js